import { render } from "./Checkbox.vue?vue&type=template&id=b47683a2&scoped=true&lang=pug"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=b47683a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b47683a2"

export default script